import {useMemo} from 'react'
import {useComparisonInfo, useSelectedRange} from '../stores/selectors'
import {getButtonTextFromCommitData} from '../helpers/commit-label-helpers'

/**
 * Hook that computes the label text for commit selection.
 *
 * @param commitOids - Array of commit OIDs in chronological order
 * @returns The formatted label text (e.g. "All commits", "Commit abc1234", "abc1234..def5678", etc)
 */
export function useCommitSelectorLabel(commitOids: string[]): string {
  const {baseOid: startOid, headOid: endOid} = useSelectedRange()
  const {
    fullDiff: {baseOid: baseRefOid},
  } = useComparisonInfo()

  const firstCommitInRange = useMemo(() => {
    if (!startOid) return

    if (startOid === baseRefOid) return commitOids[0]

    const startIndex = commitOids.findIndex(oid => oid === startOid)
    if (startIndex < 0) return

    return commitOids[startIndex + 1]
  }, [baseRefOid, commitOids, startOid])

  return getButtonTextFromCommitData({endOid, startOid, firstCommitInRange})
}
